export const CMSIcon = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 3.66667C13 5.14 10.3133 6.33333 7 6.33333C3.68667 6.33333 1 5.14 1 3.66667C1 2.19333 3.68667 1 7 1C10.3133 1 13 2.19333 13 3.66667Z" fill="white" />
            <path d="M13 3.66667C13 5.14 10.3133 6.33333 7 6.33333C3.68667 6.33333 1 5.14 1 3.66667M13 3.66667C13 2.19333 10.3133 1 7 1C3.68667 1 1 2.19333 1 3.66667M13 3.66667V7M1 3.66667V7M13 7C13 8.47333 10.3133 9.66667 7 9.66667C3.68667 9.66667 1 8.47333 1 7M13 7V10.3333C13 11.8067 10.3133 13 7 13C3.68667 13 1 11.8067 1 10.3333V7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
};

export default CMSIcon;
